import {TextEditor} from "./TextEditor.js";
import {DateTimeInput, TimePolicy} from "./DateTimeInput.js";


export class DateTimeEditor extends TextEditor {
	constructor(parent, fieldPath, obj, member, widgetOptions) {
		super(parent, fieldPath, obj, member, widgetOptions);
		if (typeof this.options.timePolicy === 'undefined') this.options.timePolicy = TimePolicy.DATETIME;
	}

	rebuild() {
		this.widget = this.makeWidget();

		this.root = $('<div class="dt-editor"></div>');
		this.root.append(this.widget);
		this.dateTimeInput = new DateTimeInput(this.widget, () => {
			return this.data;
		}, (d) => {
			this.data = d;
		}, this.options.timePolicy, this.options.symbolic);
		if (typeof this.options.defaultHour === 'number') this.dateTimeInput.defaultHour = this.options.defaultHour;
		this.dateTimeInput.updateScreen();
		this.dateTimeInput.register(this.field);
	}


	makeWidget() {
		const w = super.makeWidget();
		//w.addClass('mono');
		w.css('width', TimePolicy.allowTime(this.options.timePolicy) ? '140px' : '96px');
		return w;
	}

	format(date, wholeDay) {
		alert("format called");
		return DateTimeEditor.formatDate(date, wholeDay ? this.datePattern : this.dateTimePattern);
	}

	static formatDate(date, pattern) {
		if (date === null) return '';
		const year = date.getFullYear().toString();
		let month = (date.getMonth()+1).toString();
		let day = date.getDate().toString();
		let hours = date.getHours().toString();
		let minutes = date.getMinutes().toString();
		let zmonth = month.length === 1 ? '0'+month : month;
		let zday = day.length === 1 ? '0'+day : day;
		let zhours = hours.length === 1 ? '0'+hours : hours;
		let zminutes = minutes.length === 1 ? '0'+minutes : minutes;
		return pattern.replace('yyyy', year)
			.replace('MM', zmonth)
			.replace('dd', zday)
			.replace('HH', zhours)
			.replace('mm', zminutes)
			.replace('M', month)
			.replace('d', day)
			.replace('H', hours)
			.replace('m', minutes);
	}


	fromData(d) {
		// Format for user
		let dtObj = DateUtil.parseDate(d);
		if (dtObj.date) {
			return this.format(dtObj.date, dtObj.wholeDay);
		}
		return '';
	}

	toData(d) {
		let dtObj = this.parse(d);
		if (dtObj.date === null) return null;
		return DateUtil.formatDate(dtObj.date, !dtObj.wholeDay);
	}
}
